import { render } from "./importSoal.vue?vue&type=template&id=8cc7ea80&scoped=true"
import script from "./importSoal.vue?vue&type=script&lang=js"
export * from "./importSoal.vue?vue&type=script&lang=js"

import "./importSoal.vue?vue&type=style&index=0&id=8cc7ea80&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc7ea80"]])

export default __exports__